module.exports = __webpack_public_path__ + "static/media/fish.3c56a5b6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mm/fish.svg
// module id = 1116
// module chunks = 0